<template>
  <div class="uk-container">
    <div class="uk-flex-center" uk-grid>
      <div class="uk-width-large">
        <div class="uk-card uk-card-default uk-margin">
          <div class="uk-card-header uk-text-center">
            <h3 class="uk-card-title" data-cy="account-form-title">Account Information</h3>
          </div>
          <div class="uk-card-body">
            <form-user ref="form-user" type="new" :form.sync="user" />
          </div>
        </div>

        <div class="uk-card uk-card-default uk-margin">
          <div class="uk-card-header uk-text-center">
            <h3 class="uk-card-title">Practice Information</h3>
          </div>
          <div class="uk-card-body">
            <form-practice ref="form-practice" type="new" :form.sync="practice" />
          </div>
        </div>

        <div class="uk-text-center">
          <button class="uk-button uk-button-primary" data-cy="dentist-btn-create" @click="create">Create</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formUser from '@/components/form/User.vue'
import formPractice from '@/components/form/Practice.vue'

export default {
  name: 'ViewDentistCreate',

  components: {
    formUser,
    formPractice
  },

  data() {
    return {
      practice: null,
      user: null
    }
  },

  methods: {
    async create() {
      const loader = this.$loader.show()
      loader.setText('Preparing Data')

      const valid = {
        account: await this.$refs['form-user'].validate(),
        practice: await this.$refs['form-practice'].validate()
      }

      const result = {
        account: null,
        practice: null
      }

      let geopoint = null

      if (valid.account && valid.practice) {
        try {
          geopoint = new this.$firebase.firestore.GeoPoint(Number(this.practice.location.geopoint.lat), Number(this.practice.location.geopoint.long))
        } catch (error) {
          this.$uikit.notification(error, { status: 'danger' })
        }

        const practice = {
          availability: {},
          name: this.practice.name,
          email: this.practice.email,
          area: this.practice.area.uid,
          phone: {
            primary: this.practice.phone.primary,
            secondary: this.practice.phone.secondary
          },
          location: {
            house: this.practice.location.house,
            street: this.practice.location.street,
            city: this.practice.location.city,
            postcode: this.practice.location.postcode,
            geopoint
          },
          features: this.practice.features,
          notifications: this.practice.notifications,
          status: this.practice.status
        }

        try {
          loader.setText('Creating Practice Document')
          result.practice = await this.$firebase.firestore().collection(this.$globals.firebase.collection.dentists).add(practice)

          if (result.practice.id) {
            loader.setText('Creating User Record')
            const createUser = this.$firebaseFunctions.httpsCallable('createUser')
            const { user } = this
            console.log(user)
            user.type = 3
            user.dentist = result.practice.id

            result.account = await createUser(user)
          } else {
            // Remove Practice and Availability documents form database if creation of user record fails.
            result.practice = await this.$firebase.firestore().collection(this.$globals.firebase.collection.dentists).doc(result.practice.id).delete()
            this.$uikit.modal.alert('Something went wrong!')
          }
        } catch (error) {
          this.$uikit.notification(error, { status: 'danger' })
        }

        if (result.account && result.account.data.status === 'success') {
          await loader.hide()
          const modal = this.$uikit.modal.alert('Practice and Account were created successfully!')
          modal.dialog.$el.setAttribute('data-cy', 'dentist-create-modal-success')
          modal.dialog.$el.querySelector('.uk-button-primary').setAttribute('data-cy', 'dentist-create-modal-success-btn')
          this.$router.push({ name: 'dentist-list' })
        } else {
          loader.hide(true)
          this.$uikit.modal.alert('Something went wrong!')
        }
      } else {
        loader.hide('true')
        this.$uikit.notification('Please check provided data.', { status: 'danger' })
      }
    }
  }
}
</script>
